import {registerPaymentMethod} from '@woocommerce/blocks-registry';

const options = {
    name           : 'mame_twint',
    label          : <span class="wc-block-components-payment-method-label">
        {mameTwFrontend.title + ' '}
        <img src={mameTwFrontend.icon}/>
    </span>,
    ariaLabel      : 'Twint for WooCommerce',
    content        : <div>{mameTwFrontend.description}</div>,
    edit           : <div></div>,
    canMakePayment : () => true,
    paymentMethodId: 'mame_twint',
    supports       : {
        features: ['products'],
    },
};

registerPaymentMethod(options);